module.exports = __webpack_public_path__ + "img/coronavirus3.687f3873.jpg";